import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetailsService {
  book: number;
  article: number;
  monthlyCoin: number;
  intialCoin: number;
  newsLetter: number;
  coinOfferTypeId: number;
  subsOfferTypeId: number;
  statusId: number;
  loginAdmin: number;
  loginUser: number;
  loginSuperAdmin: number;
  sgAdmin:number;
  clientAdmin:number;

  constructor() {
    this.loginSuperAdmin = 1;
    this.loginUser = 2;
    // this.loginAdmin = 3;
    this.sgAdmin = 4;
    this.clientAdmin = 5;
    this.statusId = 60;
    this.subsOfferTypeId = 53;
    this.coinOfferTypeId = 54;
    this.newsLetter = 55;
    this.intialCoin = 56;
    this.monthlyCoin = 57;
    this.article = 58;
    this.book = 59;
  }

}
